const getLang = function () {
    var local = window.localStorage.getItem("lang");
    if(!local) {
        local = "zhCn";
    }
    return local;
}


const getMenus = function () {
    var local = window.localStorage.getItem("menus");
    if(local) {
        local = JSON.parse(local);
    } else {
        local = [];
    }
    return local;
}

const getAccount = function () {
    var local = window.localStorage.getItem("account");
    if(local) {
        local = JSON.parse(local);
    } else {
        local = {};
    }
    return local;
}

const getAuthorityList = function () {
    var local = window.localStorage.getItem("authorityList");
    if(local) {
        local = JSON.parse(local);
    } else {
        local = {};
    }
    return local;
}

const getExpiresDate = function () {
    var local = window.localStorage.getItem("expiresDate");
    return local;
}

const getAccessToken = function () {
    var local = window.localStorage.getItem("accessToken");
    return local;
}

const getRefreshToken = function () {
    var local = window.localStorage.getItem("refreshToken");
    return local;
}

const getCurrentBusinessLine = function(){
    var local=window.localStorage.getItem("currentBusinessLine");
    return local;
}

export default {
    state: {
        menus:getMenus(),
        account:getAccount(),
        authorityList:getAuthorityList(),
        lang: getLang(),
        expiresDate: getExpiresDate(),
        accessToken: getAccessToken(),
        refreshToken: getRefreshToken(),
        currentBusinessLine:getCurrentBusinessLine(),
    },
    mutations: {
        setMenus(state,menus) {
            localStorage.setItem('menus', JSON.stringify(menus))
            state.menus = menus;
        },
        setExpiresDate(state,expiresDate ) {
            localStorage.setItem('expiresDate', expiresDate)
            state.expiresDate = expiresDate;
        },
        setAccessToken(state,accessToken ) {
            localStorage.setItem('accessToken', accessToken)
            state.accessToken = accessToken;
        },
        setRefreshToken(state,refreshToken ) {
            localStorage.setItem('refreshToken', refreshToken)
            state.refreshToken = refreshToken;
        },
        setAccount(state,account) {
            localStorage.setItem('account', JSON.stringify(account))
            state.account = account;
        },
        setAuthorityList(state,authorityList) {
            localStorage.setItem('authorityList', JSON.stringify(authorityList))
            state.authorityList = authorityList;
        },
        setLang(state,lang) {
            localStorage.setItem('lang', lang);
            //$http.get('/api/changeLang?lang='+lang).then((response)=>{
            //    console.log("set Lang:" + lang + ":"+ response.data);
            //});
            state.lang = lang;
        },
        setCurrentBusinessLine(state,currentBusinessLine){
            localStorage.setItem('currentBusinessLine', currentBusinessLine)
            state.currentBusinessLine = currentBusinessLine;
        },
    },
    actions: {
        setLang({ commit, state }, lang) {
            commit('setLang', lang);
        },
        setExpiresDate({ commit, state }, expiresDate) {
            commit('setExpiresDate', expiresDate);
        },
        setAccessToken({ commit, state }, accessToken) {
            commit('setAccessToken', accessToken);
        },
        setRefreshToken({ commit, state }, refreshToken) {
            commit('setRefreshToken', refreshToken);
        },
        setMenus({ commit, state }, menus) {
            commit('setMenus', menus);
        },
        setAccount({ commit, state }, account) {
            commit('setAccount', account);
        },
        setAuthorityList({ commit, state }, authorityList) {
            commit('setAuthorityList', authorityList);
        },setCurrentBusinessLine({ commit, state }, businessLine) {
            commit('setCurrentBusinessLine', businessLine);
        },clearGlobal({ commit, state }) {
            commit('setMenus', []);
            commit('setExpiresDate',null);
            commit('setAccessToken','');
            commit('setRefreshToken','');
            commit('setAccount', {});
            commit('setAuthorityList', []);
            commit('setCurrentBusinessLine',null)
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/security.js